import React from 'react';
import PlaceholderTab from './PlaceholderTab';

function DayBeforeTab() {
  return <PlaceholderTab tabName="Day Before" />;
}

export default DayBeforeTab;
